import React, { useEffect } from 'react';
import "./loader.css"
import loaderGif from "../../../assets/gif/lmsLoader.gif"

const PageLoader = ({ visible }) => {
    useEffect(() => {
        if (visible) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        }
    }, [visible])
    if (!visible) return null;
    return (
        <div className="fullpage-loader-overlay">
            <div className="loader-circle">
                <img src={loaderGif} alt="Loading..." />
            </div>
        </div>
    );
};

export default PageLoader
